import config from 'libs/config';

export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue, options) {
    // ES6 way of const job = options.job
    // Add $plugin instance method directly to Vue components
    Vue.prototype.$log = this.log;
  },
  log (...values) {
    if (config.isDebug) {
      console.log(...values);
    }
  }
};
